
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from 'src/environments/environment';
import { TrustpilotRequest  } from '../models/trustpilot.model';

@Injectable()
export class TrustpilotService {
  constructor(private http: HttpClient) {}

  requestTrustpilotReview(data: TrustpilotRequest) {
    return this.http.post(
      environment.trustpilotReviewUrl,
      JSON.stringify(data)      // to force Content-Type: text/plain
    );
  }
}
